import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/core';

import OnOffByScroll from '../Animation/onOffByScroll';
import ScrollToTop from '../General/scrollToTop';
import { images as imageApi } from '../Apis/apis';
import Footer from '../Footer/footer';
import { ogpGenerator } from '../ogp';

const useStyles = makeStyles((theme) => ({
  container: {
    marginRight: 'calc(50% - 50vw)',
    marginLeft: 'calc(50% - 50vw)',
    height: '88vh',
    position: 'relative',
  },
  topImage: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // filter: 'contrast(150%) grayscale(100%) saturate(0%)',
    objectPosition: '0% 20%',
  },
  header: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
  },
  title: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'start',
    flexFlow: 'column',
    color: '#FFF',
    width: '100%',
    textAlign: 'start',
    padding: '40px 64px',
    background: 'rgb(0,0,0,0.8)',
    '& > div': {
      fontSize: '3rem',
    },
    '& #person': {
      display: 'flex',
      flexWrap: 'nowrap',
      fontSize: '2rem',
      gap: '0px 8px',
      '& > div': {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        lineHeight: '2rem',
        '& > span': {
          display: 'inline-block',
          fontSize: '0.8rem',
        },
      },
    },
    '@media screen and (max-width:900px)': {
      padding: '40px 24px',
      '& > div': {
        fontSize: '2.5rem',
        marginBottom: '16px',
        lineHeight: '3rem !important',
      },
      '& #person': {
        justifyContent: 'start',
        alignItems: 'center',
        lineHeight: '0.5rem',
        fontSize: '0.9rem',
        '& > div': {
          display: 'inline-block',
          fontSize: '1.5rem',
          textAlign: 'center',
          lineHeight: '1.5rem !important',
          marginLeft: '16px',
          '& > span': {
            fontSize: '0.8rem !important',
          },
        },
      },
    },
    '@media screen and (max-width:450px)': {
      padding: '40px 8px',
      '& > div': {
        fontSize: '1.5rem',
        lineHeight: '2rem !important',
        // marginBottom: '16px',
      },
      '& #person': {
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: '0.5rem',
        fontSize: '1.5rem',
        '& > div': {
          display: 'inline-block',
          fontSize: '1.2rem',
          textAlign: 'center',
          lineHeight: '1rem !important',
          marginLeft: '0px',
          '& > span': {
            fontSize: '0.5rem !important',
          },
        },
      },
    },
  },
  br: {
    display: 'none',
    '@media screen and (max-width:900px)': {
      display: 'inline',
    },
  },
  contentContainer: {
    margin: '176px 160px 0px 160px',
    textAlign: 'justify',
    fontSize: '1rem',
    '@media screen and (max-width:1400px)': {
      margin: '176px 80px 0px 80px',
    },
    '@media screen and (max-width:1000px)': {
      margin: '176px 40px 0px 40px',
    },
    '@media screen and (max-width:750px)': {
      margin: '176px 16px 0px 16px',
    },
  },
  conversationWrapper: {
    marginTop: '208px',
  },
  contentBlock: {
    '& > div': {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'top',
      letterSpacing: '0.1rem',
      '& > span': {
        display: 'inline-block',
        width: '15%',
        paddingTop: '20px',
        fontSize: '0.8rem',
      },
      '& > p': {
        width: '85%',
        textAlign: 'justify',
        fontSize: '1rem',
      },
    },
  },
  contentImage: {
    marginTop: '172px',
    marginRight: 'calc(50% - 50vw)',
    marginLeft: 'calc(50% - 50vw)',
    marginBottom: '172px',
    height: 'auto',
    '& > img': {
      display: 'inline-block',
      width: '100%',
      height: 'auto',
      objectFit: 'cover',
    },
  },
  contentImageDouble: {
    marginTop: '172px',
    marginRight: 'calc(50% - 50vw)',
    marginLeft: 'calc(50% - 50vw)',
    marginBottom: '172px',
    height: 'auto',
    '& > img': {
      display: 'inline-block',
      width: '50%',
      height: 'auto',
      objectFit: 'cover',
    },
  },
}));

const MediaContentShinkaratedo = () => {
  const [image, setImage] = useState();

  const location = useLocation();
  const classes = useStyles();

  // OGP設定
  const ogp = useCallback((props) => {
    ogpGenerator(props);
  }, []);

  useLayoutEffect(() => {
    if (image) {
      const ogpProps = {
        page: 'media_example',
        pageTitle: '刀禪OfficialWebSiteメディア掲載事例紹介',
        path: location.pathname,
        imageUrl: image.OfficialImage_TouzenLogoBlack.url,
      };
      ogp(ogpProps);
    }
  }, [image, location, ogp]);
  // OGP設定ここまで

  useEffect(() => {
    imageApi(setImage);
  }, []);

  const contents = () => {
    if (image) {
      return (
        <>
          <div className={classes.container}>
            <img
              className={classes.topImage}
              src={image.MediaPageImages_shinKarateDoTopImage.url}
              alt="topImage"
            />
            <div className={classes.header}>
              <OnOffByScroll place="TopPageHeader" />
            </div>
            <div className={classes.title}>
              <div>
                座談会
                <br className={classes.br} />
                「刀禅を空手に活かす！」
              </div>
              <div id="person">
                <div>
                  小用茂夫
                  <span>（刀禅創始者）</span>
                </div>
                <br />
                <span>×</span>
                <br />
                <div>
                  高久昌義
                  <span>（錬空武館）</span>
                </div>
                <br />
                <span>×</span>
                <br />
                <div>
                  数見肇
                  <span>（数見道場）</span>
                </div>
              </div>
            </div>
          </div>
          <ScrollToTop />
          <div className={classes.contentContainer}>
            <p style={{ fontWeight: 'bold' }}>
              刀禅というボディワークが注目されています。
            </p>
            <p style={{ textIndent: '1rem', marginTop: '176px' }}>
              武道・武術を志している人を中心に創始者である小用茂夫師の元に集い身体の根幹を見つめ開発しています。
              小用茂夫師は新陰流、形意拳、大東流などの武道・武術修練の経験から身体を突き詰めて練行してきて刀禅として
              体系化しました。その練行は見たところ何をしているのか分からない練行です。
              自らの身体でもって体感してこそ初めて理解できるものです。「立つ、歩く」という人間の基本動作を掘り下げていくとどうなるのか。
              刀禅に取り組む人は武道・武術関係者が多い中、極真空手で活躍して数々の試合で実績を残してきた錬空武館・高久昌義館長と
              数見道場・数見肇館長も刀禅に取り組んでいるメンバーです。
              小用茂夫師と高久昌義館長と数見肇館長にいつも行われている酒宴の場で「刀禅を空手に活かす！」
              というテーマで座談会をしていただきました。
            </p>
            <p style={{ textAlign: 'end', marginTop: '32px' }}>
              （協力/刀禅駒込稽古会・辻谷和輝、写真提供/刀禅会）
            </p>
            <div className={classes.conversationWrapper}>
              <div className={classes.contentBlock}>
                <div>
                  <span>小用</span>
                  <p>
                    自粛で刀禅稽古会も休みにして家に籠っていました。コロナ休暇を満喫しています。（笑）
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    コロナの影響で6月から道場稽古を再開しました。密を避ける為に人数を分けてクラスを増やしています。合間の休憩時間に自分の稽古をしていますがまさに刀禅練行をやっています。刀禅はどこでもできる練行ですからいいですね。型はナイハンチとサンチン、セーサンを中心にやり棒は常に手に持つようにしています。あと自転車で走るトレーニングをしています。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>この間は自主稽古量が増えましたね。</p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    刀禅は高久館長から紹介していただき始めました。型を突き詰めていくと繊細な部分があり、刀禅のやり方が型にあてはめられました。それは基本から型、組手も同様です。もっと言えば日常生活があてはまります。刀禅の稽古は全て小用先生が開発されたのですか？
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    きっかけは腰椎の圧迫骨折や故障もあり、それらをなんとかしたい、その切実感からいろんなことを試すなかで産まれた。リハビリ法ですね。あと、虚弱だったので。（笑）とにかく実効性の高い方法を求めて試行錯誤を繰り返しました。自分の欠陥が補われて以降は、より高いレベルに到達する方法を模索するようになっていきました。私はまた素晴らしい先生方に指導を仰ぐことが出来ました。そこで武術の高い境地を知り身体の可能性の深さに驚嘆しました。一方でレベルの埋めがたい差に限界を感じる自分の体たらく。で、武術の道は無理だなと諦め、酒の道を選び毎晩飲み明かしていました。（笑）ただ、もう一度この身体に関わるならば、この挫折をなんとかしないわけにはいきません。いわば最後の挑戦ですね。上達に効果のある方法をいろいろ探しました。他で見つからなければ練行を重ねる中で見出していく。それを繰り返しいったわけです。刀禅にオリジナルな練行が多いのもそのせいですね。刀禅が今あるのも、上達の保証も歴史的な権威もなんにも無い。そんな時代に付き合ってくれた奇特な人たちのお陰です。地味で退屈な実験をこれでもかと繰り返せたことが貴重でした。皆、文句も言わず？　そういえば初めの頃はだいぶ文句もいわれましたね（笑）。刀禅はいろんな方の御世話になりながら少しずつ出来上がってきたわけです。今もその途上にあるわけですが。その過程でつくづく感じたのは、良い流儀は現存する。しかし、現代人に必要な実効性のある方法はなかなか見出し難い。複雑な仕組みのなかに、隠されているのか、これじゃ私のような凡人には一生かかってもわかんない。（笑）逆に刀禅の方法はますます単純になっていった。（笑）　今では「単純だからこそ本源に迫ることができる」と自信をもってきました。だからといって単純ならなんでもいい、というわけでは、もちろんありません。やはりピントは合ってないと。（笑）刀禅が日常性のなかで何時でも何処でも出来るというのも単純だからですね。それがあるから短期間で身体の変容も得やすいのだと思っています。
                  </p>
                </div>
              </div>
              <div className={classes.contentImage}>
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image1.url}
                  alt="image1"
                />
              </div>
              <div className={classes.contentBlock}>
                <div>
                  <span>高久</span>
                  <p>
                    型をやっている際、一瞬の動きの中にどれだけ密度を高めていくのかに気づきました。ひとつ前のところから次にいく間を埋めていった先にこの形になっている。これがないと形だけの空洞な型になってしまいます。
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    そうですね。掛け拳練行（二人で組み手首を合わせてお互いの力を通し合う練行）をやり始めて身体の内部の流通路が出来てくるとより内部から動くようなります。その中にいろんな発見がありお互いの身体に還元されていきます。そこからある種のつながりが連鎖してきてグワーンというようなエネルギーの流れがよびこまれるような、息吹が輝くような、指先まで躍動するような感じになってきます。そのエネルギー源、源泉を練行で培っていかないと型は形だけのものになりがち。そうしたエネルギーは型の中身ですね。形にエネルギーを補填していけるようになると、型はそのぶん良くなる。逆に型をやることでエネルギーが整えられたり配分が分かってくるという良い循環ですね。型とその中身との相乗的な良い関係ができてくれば両方ともどんどん良くなってくる。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    ナイハンチの初めの挙動（ナイハンチ立ちで右手開手）はすごく威力があります。最初は形をなぞっていきますが、刀禅で内部を作り足裏からつないでやると威力の出方、身体の満ち足りた感があり感動します。これは刀禅で前の作業を埋めていくことがあったからこそ得られた感動です。
                  </p>
                </div>
                <div>
                  <span>編集部</span>
                  <p>刀禅をやることにより型は変わりますか？</p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    大いに変わります。外枠（形）もきれいに作ることも出来て、中味がつまっていった状態であれば動作の途中であっても威力はあり形が決まった状態の時には感動がでると感じました。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    自分は足裏から力を出すということを刀禅に出会うまで知りませんでした。刀禅を型に当てはめて行なうと型が身体を練るものだと分かってきました。これがないと型をやっても変わらないと思います。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>ギアが浅い感じですね。</p>
                </div>
              </div>
              <div className={classes.contentImage}>
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image2.url}
                  alt="image2"
                />
              </div>
              <div className={classes.contentBlock}>
                <div>
                  <span>編集部</span>
                  <p>生徒への指導の際にそのあたりの説明はされますか？</p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    説明しています。四股立ちの際など足裏でしっかりつかみ踵に乗るように立ち押さえる力を意識させます。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    立ち方のレの字立ちや猫足立ちは刀禅の一線歩行に近い立ち方です。生徒で上体が浮いている状態の際、踵に意識を通す指導をして背中をアーチ状にすると崩れない強い立ち方になります。立ち方に奥行きがでてきます。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    組手の際にも刀禅の基本である骨盤を入れた状態でやります。
                  </p>
                </div>
                <div>
                  <span>辻谷</span>
                  <p>
                    自分が稽古している空手道場では、刀禅を意識して稽古しており道場生で尋ねてきた人には伝えています。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>刀禅に出会ってから空手の指導法がかなり変わりました。</p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    先人たちが作り上げてきた貴重な遺産を受けるためには、先にこちらの身体を変えていかないと読み解けないし、受け取れない。次へバトンも渡せない。「難しい」で終わってしまってはあまりにも勿体ないと思うわけです。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    型を組手に活かすという課題があります。一般的に格闘技のワンツー突きは後ろ足の踵は上げて突きます。しかし、打つ際に踵つけて突く方が明らかに力がのります。この突き方は上級者向けで初級者には難しいと思います。指導には段階があり生徒に教える場合には、最初から指導するべきか考えていますがいかがでしょうか？
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    刀禅でやっていることは土台作りのための踵重心です。闘う場合、
                    常に踵重心でなければならないということではありません。身体を作るプロセスで踵重心は大事です。
                    踵とつま先の関係からいうと踵から作らないとつま先に上手く通じることが難しくなります。
                    格闘の場で有効に間に合わせるかということと根元的に身体を作ることとは同時には出来ません。
                    用所に応じて変化させなければなりません。踵からいかにつなげていくか。踵を浮かす時も無自覚ではいけない。
                    根元的な身体作りで踵を重視するわけで踵からつま先や足裏全体に広げることもあります。
                    力が抜けることがありません。踵を着けるのは軸を作り全体につなげるのに不可欠だからです。
                    踵が浮いている時も有効に作用しておりあとは使い方の問題です。つまり、踵を着けているからこそ活かせる。
                    身体の上下を通してつなげ、先ずは活かせる身体を作ることです。
                    身体造りという観点からは初心者こそ強く踵を意識させ踏ませた方が良いと思います。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    身体が出来てくれば踵を着けていようが上げていようが同じ感覚でいられるということですね。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    従来の格闘技の稽古法でも強くなってきてモチベーションを維持していくのも大切で段階的に指導出来ればと思います。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    自分の道場ではステップ蹴り、いわゆるギャリーステップも教えてやらせていますが生徒は喜んで取り組んでいます。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    自分が追求しているものと生徒への指導は温度差があります。生徒たちには空手を楽しみ続けてもらいたいので、ある程度レベルも上がってきて熟練してきたら段階的に指導するべきかとも考えています。自分が空手を始めた時と今では状況が違いますね。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    それは感じますね。組手では細かいことはあまり言わず、型の際には刀禅的な感覚を入れ込んでやっています。型稽古で身についてきたら組手も安定してきます。
                  </p>
                </div>
                <div>
                  <span>辻谷</span>
                  <p>そのやり方は昔の沖縄空手と同じですね。</p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    昔の沖縄の先生は細かく教えなかったようです。刀禅のエッセンスを基本から稽古の中に組み込んでいます。
                    自分が育った極真城南支部の廣重毅師範は武術的な空手で競技でも勝つ指導をされました。
                    勝ち方でも師範の教えと違う勝ち方をしたら喜んでくれませんでした。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    廣重師範の指導は、試合ルールとは関係のない練習がたくさんありました。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    廣重師範はその選手の長所を伸ばすことに長けていました。廣重師範の武術的な指導を受けたことも刀禅を学ぶ上で役に立ちました。刀禅には高久館長のお勧めと紹介で知りましたが、実は15年以上前に格闘技の出版社が集まった宴会があり、
                    そこで小用先生にお会いしています。その時は新陰流をやっていると聞きました。
                  </p>
                </div>
                <div>
                  <span>編集部</span>
                  <p>
                    その時は小用先生がファンとして数見館長に記念写真をお願いしましたね。（笑）
                    数見館長が刀禅を初めてやった時の印象はどうでしたか？
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    動きがなく姿勢をつくるのが難しかったです。
                    当時は直立禅（両足を揃えて踵重心で真っすぐに立つ）、合掌行（直立禅から両手をゆっくり前に出し合わせる）
                    、盤旋行（直立禅のまま腰を水平に左右回転させる）、木刀を使った二線球磨
                    （二人で組み木刀を両手で持ち一点を合わせて通し合う）の練行でした。
                    やればやる程に刀禅の深さを感じます。
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    こちらも高久館長と数見館長が来て一緒に何が出来るのか考えて打拳練行（
                    お互いに拳を合わせて通し合う）が始まりました。打拳練行は拳を通してお互いの深部に浸透し通じ合え、
                    育みあえます。お二人のお陰で新しい練行世界が生まれました。
                  </p>
                </div>
              </div>
              <div className={classes.contentImageDouble}>
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image3.url}
                  alt="image3"
                />
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image4.url}
                  alt="image4"
                />
              </div>
              <div className={classes.contentBlock}>
                <div>
                  <span>高久</span>
                  <p>
                    拳は自分たちの専門ですが小用先生と拳を合わせた説得力は衝撃でした。
                    木刀を使った球磨も衝撃でしたが、打拳練行があり衝撃的に身体で理解出来ました。打拳練行は最初、
                    通常の正拳突きから縦拳、下突き拳、掛け拳、掛け掌といくつかのパターンが生まれました。
                    深い部分から力を出すことも打拳練行から学びました。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    打拳練行で突きの概念が変わりました。特に屈伸を使わない概念は大きかったです。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    屈伸の突きよりも刀禅の通した突きの方が資源がたくさんありますね。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>その突きをどのように組手で使うかですね。</p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    そこですね。構えを崩さず、引き手を最小限に抑えたまま攻防に活かせる
                    ようになると良いですね。高久館長はすでに『掛け試し稽古会』で実践されています。
                    また辻谷さんは刀禅入会当初から習ったことを即組手で試しています。その都度、
                    詳しく報告をして下さるのですが、それがまたとても参考になります。
                    組手試合では頂点を極めた経験豊富なお二人のご意見と探求に期待したいところです。
                    そういえば初めて数見館長にお目にかかったとき、一緒の方に「組手に役立てられるものはありますか？」
                    と問われて、私が「ありません」と答えたことを思い出しました。（笑）そのころは本当になかったはずです。
                  </p>
                </div>
              </div>
              <div className={classes.contentImageDouble}>
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image5.url}
                  alt="image5"
                />
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image6.url}
                  alt="image6"
                />
              </div>
              <div className={classes.contentBlock}>
                <div>
                  <span>数見</span>
                  <p>
                    次に重心移動についてお聞きします。
                    移動するのは重心の移動により足が出るのか、一般的な足を蹴るように出る方法や丹田から出るような方法、
                    脱力して出る方法などありますがどこから移動するのでしょうか？
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    これは本質的な面白い課題で常に問われます。
                    しかし具体的にどこからと特定するのは難しいです。分離した身体であればどこからと特定したほうがいいのかも、
                    ですが。自在に移動できるとはどのようなことなのか。その為には身体の中にルートを作らなければならない。
                    ルートが出来ると闊達自在が当たり前のことになります。そのルートをどのように作るのかが一番大切です。
                    人間は直立二足歩行で動作の連関がうまくいかなくなった。移動する際に分離しやすくなります。
                    武術はこの分離をいかにつなげ隙間をなくしていくかを追求したものでもあると思います。
                    しかし、つなげるための具体的で明確な方法はあまり提示されていません。
                    刀禅では先ずは身体の上下をつなげる回路を作ります。頭部や伸ばした手から一番遠い踵から腹部の内圧に
                    つなげて常に内部で躍動している状態ですね。ここには分離が少なく、そのぶん必要最小限の動作を生み出しやすい。
                    身体の内側でつなげる回路ですね。繋がってくれば同時相関的にすべてが動く。部位としてどこから動くというよりも、
                    見えない内部の濃淡の微妙な差違のなかで、無作為に動きは生まれてしまう。
                    その時の状況によって無意識に選択されてしまう。それを動画などで分析すればとこから動いているということになる。
                    けれどもそれは現象に過ぎない。ただ、動きの動源はつねに下にある、とはいえると思います。
                  </p>
                </div>
                <div>
                  <span>辻谷</span>
                  <p>
                    つながりを作るための身体の基準をしっかり作ればおのずと動きが生まれてくるということですね。
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>言ってみれば禅の境地の動的な展開ですかね。</p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    AからBにしか動けないという一つの方向にしか行けないことは、動いている中でも居付いているということですね。
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    刀禅は踵を着けて立ち止まっているので居付いていると思われますがちょっと違いますね。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>止まって見える中にダイナミックなうごめきがあります。</p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    立つこと歩くことを丁寧に掘り起こしていくなかに限りない可能性があると思います。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    刀禅にふれて自分の足りないところが鮮明になりました。身体の内部の部分です。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    極真世界大会でフランシスコ・フィリョ選手と試合して一歩踏み込んだらカウンターの横蹴りで倒されました。一か八かの一歩でしたが、この一歩の中に細かいつなぎがあれば融通無碍に変化し対応出来たことかと思います。
                  </p>
                </div>
                <div>
                  <span>辻谷</span>
                  <p>
                    自分はフルコン系空手道場で稽古していますが、試合を目指して勝つことが目的ではなく武道として負けないためにやっています。武器の練習もやっている中、身体の軸を作ることなど根元的なものがあるだろうと刀禅を始めました。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    今の感覚として空手や格闘技の試合競技を武道だということに
                    開きを感じています。音楽や芸術と同一視できないです。音楽の世界では緻密な状態を模索しながら
                    作っている世界で高まっている。空手と格闘技はその選手の身体能力とセンスで闘っています。
                    刀禅は先ず基礎から身体の基盤作りをする。試合競技をやってきたからこそ、
                    もう一度しっかり身体作りを学びたいと思いました。今日は久しぶりに小用先生と手を合わせましたが、
                    小用先生は手を合わせる前からすでに身体の中で整った状態で準備が出来ている。
                    事が起こる前に手を打ってあるような状態です。意識するということでなく日常の中で当たり前に
                    なっているのでしょう。触れた瞬間に力が出ない状態にされてしまいます。
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    手を合わせるから分かることですね。
                    このような密着状態を持続する練行は日本武術、中国武術にも意外となかった。
                    お互いの内部にスキャンしながら強いところ、弱いところを交換し合いながらする身体のコミュニケーションです。
                    武術的には相手の薄いところ弱いところに入っていく。
                  </p>
                </div>
                <div>
                  <span>辻谷</span>
                  <p>
                    小用先生と手を合わせるとつぶされるというより圧縮洗浄のように
                    すっきりします。しばらくは通された感覚が身体の中に残ります。
                  </p>
                </div>
              </div>
              <div className={classes.contentImage}>
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image7.url}
                  alt="image7"
                />
              </div>
              <div className={classes.contentBlock}>
                <div>
                  <span>編集部</span>
                  <p>小用先生と廣重師範との共通性はありますか？</p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    城南支部でやっていた立禅、這、練の稽古は似ているところもありますが、
                    刀禅練行になると対応出来ないところもありました。似ているようで違います。
                    やっていたつもりで自分はスカスカ状態でした。
                    接触されて圧をかけられると身体が反発して自ら崩れてしまうと初めて知りました。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    自分は這と練を中心にやっていましたが深い
                    感覚的なものを得るところまでは到達できませんでした。這と練は歩法で、
                    自分の組手での足運びの原点になりました。
                    廣重師範の武術的な稽古の土壌があったから刀禅の稽古にもすんなり入れたと思います。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    大事なことは自分のバランスを崩さずにいることですが、
                    接触して圧をかけられると自分ではバランスをとっているようでも真ん中から外れていく
                    身体の機能があることに気づきました。木刀を持って二線球磨をやるといかにバランスが
                    崩れているのかよく分かります。今までやってきたことが無駄になることなくより高度化
                    できる楽しみもあります。
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    身体の中でつながって新しい感覚を得ていくことは快感ですよね。
                    日本文化の特質のひとつは、文化性を身体の外側ではなく、身体の内側に培い書き込んで、
                    いわば身体の能力自体を高度化したところ。それは世界的にもたぐい稀な例だったのではないかと
                    思っています。外来文化を喜んで受け入れ独自に花を咲かせられたのもそういった足腰の強さからくる
                    消化能力だった。しかしその培われた能力も、今や希薄化し途切れんとしているわけですね。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>その失われた緻密な身体を蘇らせるのは刀禅だと思います。</p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    少しでもそうなれれば良いのですが……。
                    もちろん残された伝統を学ぶのは貴重なことですよね。刀禅においては「土台を造り」
                    というところに特化し専念できればと思っています。身体のインフラ専門の土建業みたいなものですかね。
                  </p>
                </div>
              </div>
              <div className={classes.contentImage}>
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image8.url}
                  alt="image8"
                />
              </div>
              <div className={classes.contentBlock}>
                <div>
                  <span>編集部</span>
                  <p>最後に本日の座談会のご感想をお願いします。</p>
                </div>
                <div>
                  <span>辻谷</span>
                  <p>
                    とても勉強になり同席出来て光栄です。
                    どんな話を聞いても根元と根本は変わらないです。自分が変わっていくことにより理解が変わって
                    くるのも面白いです。高久館長と数見館長という空手の先輩たちが指針になります。
                  </p>
                </div>
                <div>
                  <span>数見</span>
                  <p>
                    本日は極意をお聞き出来ました。
                    自分が疑問に感じていたことも聞けてこれから稽古にフィードバックして活かしていきたいです。
                    基準があり行き来の新たな拡がりが出てきました。基準があるのはどれだけ心強いことか。
                    そして、自分の自由な発想をどう拡げていくかですね。
                    最後にもう一つお聞きしたいことが、這をやる時に膝をかなり曲げて行っていました。
                    刀禅は軽く膝を曲げるくらいですがこの見解はいかがでしょうか？
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    中国武術では功夫を作るには腰を落とせ、
                    膝を曲げろと多々言われます。膝を曲げて腰を落とした状態でどれだけ動けるかを課題にさせます。
                    刀禅の発想では、身体が出来ていない人が腰を落として膝を深く曲げることは分離も生じやすくマイナス。
                    後々、障害が出るのも心配です。身体をつなげて上と下の分断がなくなった時に落とすのはいいでしょう。
                    昔は低く構えたまま何時間も立たせる稽古でした。そしてとんでもない身体になった人だけが残った。
                    しかし、どうして強くなったのか自分でもよく分からないから同じように伝えるしかありません。
                    これは弟子をふるいにかけて落とすためでもあったようです。
                    私の形意拳の先生も厳しい先生に習った方でしたが、私にはとても丁寧にご指導下さいました。
                    それゆえに自分の不出来がなおさら恥ずかしくなります。しかしこの時代でそんな稽古を出来るはずも無く。
                    あっ、数見館長なら可能でしょうが（笑）。無理難題をこなしてきた人たちの水準に、
                    現代人がどこまで迫れるか、この時代にある大いなる課題だと思います。
                    逆に今を生きる日本人だからこそできる挑戦をしていければと思います。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    押忍、可能性はありますね。自分の身体で感じています。
                    元々上体の筋力が付きやすく下体は付きにくい体質まで変わってきました。
                    遺伝的な要因があったとしても補えるくらい下に通るようになり嬉しいことです。
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    自分の限界を超えて成長できる可能性ですね。それには厳格な基準と方法が前提になりますよね。
                  </p>
                </div>
                <div>
                  <span>高久</span>
                  <p>
                    今日はコロナ自粛から久しぶりに小用先生とお会いして手を
                    合わせていただき貴重な体験になりました。深いお話しから今後の指針が出来ました。
                  </p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    大切なことは、先ず費やした努力が報われていくこと。
                    自分の身体がつながっていくことによって産まれる喜び。その本源にどんどん近づいていけること。
                    そのことは先人たちがつむいできた良質な流れと深いところでつながっていくことかと思います。
                    刀禅は欠陥だらけで、まだまだ未熟です。これからもしっかり検証しあいながら一緒に探求していきましょう。
                  </p>
                </div>
                <div>
                  <span>編集部</span>
                  <p>本日はありがとうございました。</p>
                </div>
                <div>
                  <span>小用</span>
                  <p>
                    こちらこそ良い機会を作って頂き、またお三方にはご足労いただき、
                    今宵はほんによか晩じゃった、です。これに懲りず美味しいお酒を呑みましょう。（穏笑）（爆笑）？
                  </p>
                </div>
              </div>
              <div className={classes.contentImage}>
                <img
                  src={image.MediaPageImages_shin_karate_do_contents_image9.url}
                  alt="image9"
                />
              </div>
            </div>
          </div>
          <Footer />
        </>
      );
    }
  };
  return contents();
};
export default MediaContentShinkaratedo;
